export enum ClientEnvironment {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  QA = 'QA',
  STAGING = 'STAGING',
  DEMO = 'DEMO',
  PROD = 'PROD',
}

export enum VerantosOrgEnum {
  VERANTOS = 'Verantos',
}
